<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">Manage Events</h1>
    </div>
    <div>
      <img class="separator" src="../../../../assets/icons/separator.svg" alt="img" />
    </div>
    <div>
      <h1 class="sub-headeradminui-text">{{ totalCount }} Events</h1>
    </div>
  </div>
  <button
  [routerLink]="['/events/crud']"
  nz-button nzType="primary">Add Events</button>
</div>

<nz-spin [nzSpinning]="eventsSpinner" nzTip="Fetching Events....">
  <div nz-row>
    <nz-tabset (nzSelectChange)="tabChange($event)">
      <nz-tab nzTitle="Upcoming Events">
        <app-events-table
          #UpcomingTableComponent
          [eventsTableData]="tableData"
          (resetFilterEvent)="resetFilter()"
          (pageChangeEvent)="nzPageIndexChange($event)"
          (pageSizeChangeEvent)="nzPageSizeChange($event)"
          (categoryFilterEvent)="categoryFilter($event)"
          (eventsDateFilterEvent)="dateFilter($event)"
          (paymentTypeFilterEvent)="paymentTypeFilter($event)"
          (hideTestFilterEvent)="testFilter($event)"
          (activeFilterEvent)="activeFilter($event)"
          (searchEvent)="searchGlobal($event)"
        ></app-events-table>
      </nz-tab>
      <nz-tab nzTitle="Ongoing Classes">
        <app-events-table
          #OngoingClassesComponent
          [eventsTableData]="tableData"
          (resetFilterEvent)="resetFilter()"
          (pageChangeEvent)="nzPageIndexChange($event)"
          (pageSizeChangeEvent)="nzPageSizeChange($event)"
          (categoryFilterEvent)="categoryFilter($event)"
          (eventsDateFilterEvent)="dateFilter($event)"
          (paymentTypeFilterEvent)="paymentTypeFilter($event)"
          (hideTestFilterEvent)="testFilter($event)"
          (activeFilterEvent)="activeFilter($event)"
          (searchEvent)="searchGlobal($event)"
        ></app-events-table>
      </nz-tab>
      <nz-tab nzTitle="All Events">
        <app-events-table
          #AllTableComponent
          [eventsTableData]="tableData"
          (resetFilterEvent)="resetFilter()"
          (pageChangeEvent)="nzPageIndexChange($event)"
          (pageSizeChangeEvent)="nzPageSizeChange($event)"
          (categoryFilterEvent)="categoryFilter($event)"
          (eventsDateFilterEvent)="dateFilter($event)"
          (paymentTypeFilterEvent)="paymentTypeFilter($event)"
          (hideTestFilterEvent)="testFilter($event)"
          (activeFilterEvent)="activeFilter($event)"
          (searchEvent)="searchGlobal($event)"
        ></app-events-table>
      </nz-tab>
    </nz-tabset>
  </div>
</nz-spin>
</div>